/**
 * Programme credit for The Downstream Project's Water Watch, under which
 * these dashboards are deployed.
 *
 * It lives in the footer rather than the header for two reasons. A second
 * logo beside the Council's own would read as co-branding and compete with
 * whose data this is; and the mark is blue-and-teal on transparent, which
 * muddies against the navy header but sits cleanly on the white footer.
 */
export default function WaterWatchCredit() {
  return (
    <a
      className="wwcredit"
      href="https://thedownstreamproject.org/services/water-watch/"
      target="_blank"
      rel="noreferrer"
      title="Water Watch, a programme of The Downstream Project"
    >
      <span className="wwcredit-label">Part of</span>
      <img
        src="/waterwatch-logo.png"
        alt="Water Watch"
        width={110}
        height={18}
        loading="lazy"
        decoding="async"
      />
    </a>
  );
}
